import axiosInstance from "./AxiosInstance";

export default {
    get() {
        return axiosInstance({
            method: "get",
            url: "/transporter",
        });
    },
    create(body) {
        return axiosInstance({
            method: "post",
            url: "/transporter",
            data: body,
        });
    },
};
